export default __webpack_public_path__ + "static/r-pitch-3-2ee55985355f1c8702dde7ecd0a5d306.jpg";